module.exports = __webpack_public_path__ + "0f8855d8d40236b2c7aa7e405c50207c.webp";